'use strict';

exports.__esModule = true;
exports.reducer = reducer;
var FIXED = {
  byId: {
    'palermo-la-dolfina-magual': {
      heading: 'Lunes 23/11 - Partido 1 - Zona A - 14:00',
      team1: {
        id: 'la-dolfina',
        score: 18
      },
      team2: {
        id: 'magual',
        score: 7
      }
    },
    'palermo-alegría-la-aguada': {
      heading: 'Lunes 23/11 - Partido 2 - Zona A - 16:30',
      team1: {
        id: 'alegría',
        score: 17
      },
      team2: {
        id: 'la-aguada',
        score: 22
      }
    },
    'palermo-ellerstina-washington': {
      heading: 'Martes 24/11 - Partido 3 - Zona B - 14:00',
      team1: {
        id: 'ellerstina',
        score: 14
      },
      team2: {
        id: 'washington',
        score: 10
      }
    },
    'palermo-las-monjitas-chapaleufu': {
      heading: 'Martes 24/11 - Partido 4 - Zona B - 16:30',
      team1: {
        id: 'las-monjitas',
        score: 17
      },
      team2: {
        id: 'chapaleufu',
        score: 15
      }
    },
    'palermo-la-aguada-magual': {
      heading: 'Lunes 30/11 - Partido 5 - Zona A - 14:00',
      team1: {
        id: 'la-aguada',
        score: 17
      },
      team2: {
        id: 'magual',
        score: 11
      }
    },
    'palermo-la-dolfina-alegria': {
      heading: 'Lunes 30/11 - Partido 6 - Zona A - 16:30',
      team1: {
        id: 'la-dolfina',
        score: 16
      },
      team2: {
        id: 'alegria',
        score: 14
      }
    },
    'palermo-las-monjitas-washington': {
      heading: 'Domingo 29/11 - Partido 7 - Zona B - 14:00',
      team1: {
        id: 'las-monjitas',
        score: 11
      },
      team2: {
        id: 'washington',
        score: 8
      }
    },
    'palermo-ellerstina-chapaleufu': {
      heading: 'Domingo 29/11 - Partido 8 - Zona B - 16:30',
      team1: {
        id: 'ellerstina',
        score: 20
      },
      team2: {
        id: 'chapaleufu',
        score: 5
      }
    },
    'palermo-magual-alegria': {
      heading: 'Sábado 5/12 - Partido 9 - Zona A - 14:00',
      team1: {
        id: 'magual',
        score: 11
      },
      team2: {
        id: 'alegria',
        score: 18
      }
    },
    'palermo-la-dolfina-la-aguada': {
      heading: 'Sábado 5/12 - Partido 10 - Zona A - 16:30',
      team1: {
        id: 'la-dolfina',
        score: 13
      },
      team2: {
        id: 'la-aguada',
        score: 10
      }
    },
    'palermo-washington-chapaleufu': {
      heading: 'Domingo 6/12 - Partido 11 - Zona B - 14:00',
      team1: {
        id: 'washington',
        score: 15
      },
      team2: {
        id: 'chapaleufu',
        score: 12
      }
    },
    'palermo-ellerstina-las-monjitas': {
      heading: 'Domingo 6/12 - Partido 12 - Zona B - 16:30',
      team1: {
        id: 'ellerstina',
        score: 16
      },
      team2: {
        id: 'las-monjitas',
        score: 12
      }
    },
    'palermo-la-dolfina-ellerstina': {
      heading: 'Sábado 12/12 - Final - 16:30',
      team1: {
        id: 'la-dolfina',
        score: 0
      },
      team2: {
        id: 'ellerstina',
        score: 0
      }
    },
    'hurlingham-la-dolfina-washington': {
      heading: 'Martes 20/10 - Partido 1 - Zona A - 14:00',
      team1: {
        id: 'la-dolfina',
        score: 22
      },
      team2: {
        id: 'washington',
        score: 12
      }
    },
    'hurlingham-la-aguada-las-monjitas': {
      heading: 'Martes 20/10 - Partido 2 - Zona A - 16:00',
      team1: {
        id: 'la-aguada',
        score: 13
      },
      team2: {
        id: 'las-monjitas',
        score: 12
      }
    },
    'hurlingham-ellerstina-magual': {
      heading: 'Miércoles 21/10 - Partido 3 - Zona B - 14:00',
      team1: {
        id: 'ellerstina',
        score: 15
      },
      team2: {
        id: 'magual',
        score: 13
      }
    },
    'hurlingham-alegria-chapaleufu': {
      heading: 'Miércoles 21/10 - Partido 4 - Zona B - 16:00',
      team1: {
        id: 'alegria',
        score: 19
      },
      team2: {
        id: 'chapaleufu',
        score: 18
      }
    },
    'hurlingham-la-aguada-washington': {
      heading: 'Viernes 23/10 - Partido 5 - Zona A - 14:00',
      team1: {
        id: 'la-aguada',
        score: 12
      },
      team2: {
        id: 'washington',
        score: 13
      }
    },
    'hurlingham-la-dolfina-las-monjitas': {
      heading: 'Viernes 23/10 - Partido 6 - Zona A - 16:00',
      team1: {
        id: 'la-dolfina',
        score: 18
      },
      team2: {
        id: 'las-monjitas',
        score: 7
      }
    },
    'hurlingham-alegria-magual': {
      heading: 'Sábado 24/10 - Partido 7 - Zona B - 14:00',
      team1: {
        id: 'alegria',
        score: 15
      },
      team2: {
        id: 'magual',
        score: 14
      }
    },
    'hurlingham-ellerstina-chapaleufu': {
      heading: 'Sábado 24/10 - Partido 8 - Zona B - 16:00',
      team1: {
        id: 'ellerstina',
        score: 17
      },
      team2: {
        id: 'chapaleufu',
        score: 10
      }
    },
    'hurlingham-washington-las-monjitas': {
      heading: 'Lunes 02/11 - Partido 9 - Zona A- 12:00',
      team1: {
        id: 'washington',
        score: 12
      },
      team2: {
        id: 'las-monjitas',
        score: 13
      }
    },
    'hurlingham-la-dolfina-la-aguada': {
      heading: 'Sábado 31/10 - Partido 10 - Zona A - 16:00',
      team1: {
        id: 'la-dolfina',
        score: 16
      },
      team2: {
        id: 'la-aguada',
        score: 10
      }
    },
    'hurlingham-magual-chapaleufu': {
      heading: 'Lunes 02/11 - Partido 11 - Zona B - 14:00',
      team1: {
        id: 'magual',
        score: 10
      },
      team2: {
        id: 'chapaleufu',
        score: 11
      }
    },
    'hurlingham-ellerstina-alegria': {
      heading: 'Domingo 01/11 - Partido 12 - Zona B - 16:00',
      team1: {
        id: 'ellerstina',
        score: 19
      },
      team2: {
        id: 'alegria',
        score: 11
      }
    },
    'hurlingham-la-dolfina-ellerstina': {
      heading: 'Sábado 07/11 - Final - 16:00',
      team1: {
        id: 'la-dolfina',
        score: 15
      },
      team2: {
        id: 'ellerstina',
        score: 14
      }
    },
    'tortugas-alegria-chapaleufu': {
      heading: 'Martes 29/09 - Fecha 1 - Zona A - 16:00',
      team1: {
        id: 'alegria',
        score: 15
      },
      team2: {
        id: 'chapaleufu',
        score: 11
      }
    },
    'tortugas-las-monjitas-la-aguada': {
      heading: 'Miércoles 30/09 - Fecha 2 - Zona B - 16:00',
      team1: {
        id: 'las-monjitas',
        score: 10
      },
      team2: {
        id: 'la-aguada',
        score: 11
      }
    },
    'tortugas-la-dolfina-chapaleufu': {
      heading: 'Lunes 05/10 - Fecha 3 - Zona A - 15:30',
      team1: {
        id: 'la-dolfina',
        score: 20
      },
      team2: {
        id: 'chapaleufu',
        score: 6
      }
    },
    'tortugas-ellerstina-las-monjitas': {
      heading: 'Domingo 04/10 - Fecha 4 - Zona B - 15:30',
      team1: {
        id: 'ellerstina',
        score: 20
      },
      team2: {
        id: 'las-monjitas',
        score: 12
      }
    },
    'tortugas-la-dolfina-alegria': {
      heading: 'Sábado 10/10 - Fecha 5 - Zona A - 15:30',
      team1: {
        id: 'la-dolfina',
        score: 18
      },
      team2: {
        id: 'alegria',
        score: 8
      }
    },
    'tortugas-ellerstina-la-aguada': {
      heading: 'Domingo 11/10 - Fecha 6 - Zona B - 14:30',
      team1: {
        id: 'ellerstina',
        score: 17
      },
      team2: {
        id: 'la-aguada',
        score: 10
      }
    },
    'tortugas-la-dolfina-ellerstina': {
      heading: 'Sábado 17/10 - Final - Copa Emilio de Anchorena - 15:30',
      team1: {
        id: 'la-dolfina',
        score: 11
      },
      team2: {
        id: 'ellerstina',
        score: 9
      }
    }
  },
  byTournamentId: {
    'tortugas': ['tortugas-alegria-chapaleufu', 'tortugas-las-monjitas-la-aguada', 'tortugas-la-dolfina-chapaleufu', 'tortugas-ellerstina-las-monjitas', 'tortugas-la-dolfina-alegria', 'tortugas-ellerstina-la-aguada', 'tortugas-la-dolfina-ellerstina'],
    'hurlingham': ['hurlingham-la-dolfina-washington', 'hurlingham-la-aguada-las-monjitas', 'hurlingham-ellerstina-magual', 'hurlingham-alegria-chapaleufu', 'hurlingham-la-aguada-washington', 'hurlingham-la-dolfina-las-monjitas', 'hurlingham-alegria-magual', 'hurlingham-ellerstina-chapaleufu', 'hurlingham-washington-las-monjitas', 'hurlingham-la-dolfina-la-aguada', 'hurlingham-magual-chapaleufu', 'hurlingham-ellerstina-alegria', 'hurlingham-la-dolfina-ellerstina'],
    'palermo': ['palermo-la-dolfina-magual', 'palermo-alegría-la-aguada', 'palermo-ellerstina-washington', 'palermo-las-monjitas-chapaleufu', 'palermo-la-aguada-magual', 'palermo-la-dolfina-alegria', 'palermo-las-monjitas-washington', 'palermo-ellerstina-chapaleufu', 'palermo-magual-alegria', 'palermo-la-dolfina-la-aguada', 'palermo-washington-chapaleufu', 'palermo-ellerstina-las-monjitas', 'palermo-la-dolfina-ellerstina']
  }
};

function reducer(state, action) {
  if (state === undefined) state = FIXED;

  return state;
}